import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { AxiosProgressEvent } from 'axios'
import { useState } from 'react'

import { getFileContentBySignedUrl } from 'services'
import { QueryKeys } from 'services/queryKeys'
import { FileContent } from 'services/types'

export const useFileContentsQuery = (url: string, options?: Omit<UseQueryOptions<FileContent>, 'queryKey'>) => {
  // Local state to track progress (0–100)
  const [progress, setProgress] = useState(0)

  const onDownloadProgress = (event: AxiosProgressEvent) => {
    if (event.total) {
      // Calculate the percentage completed with one decimal point
      const percentCompleted = Number(((event.loaded * 100) / event.total).toFixed(1))
      setProgress(percentCompleted)
    }
  }

  const query = useQuery({
    queryKey: QueryKeys.GetFileContentsFromSignedUrl(url),
    queryFn: ({ signal }) => getFileContentBySignedUrl(url, onDownloadProgress, signal),
    enabled: !!url,
    retry: false,
    ...options
  })

  return { progress, ...query }
}

export default useFileContentsQuery
